import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';

@Component
export class CartItemCount extends ThemeComponent {

    init() {
        const updateCount = () => {
            const groupedCount = this.getGroupedItemCount();
            if (groupedCount <= 0) {
                this.classList.add('cart-item-count--hidden');
            } else {
                this.classList.remove('cart-item-count--hidden');
            }
            this.textContent = groupedCount.toString();
        };

        // Initial render
        updateCount();

        // Subscribe to cart changes
        this.$subscribe(cart.onChange, updateCount);
    }

    private getGroupedItemCount(): number {
        const seenBikeIds = new Set<string>();
        let total = 0;

        for (const item of cart.items) {
            // eslint-disable-next-line no-underscore-dangle
            const bikeId = item.properties?._bike_id as string | undefined;
            if (bikeId) {
                if (!seenBikeIds.has(bikeId)) {
                    seenBikeIds.add(bikeId);
                    total += 1;
                }
            } else {
                total += 1;
            }
        }

        return total;
    }
}
